import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { login } from '../utils/api';
import { useAuth } from '../context/AuthContext';

const LoginPage = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { loginUser } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await login(formData);
      loginUser(data);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      {/* Background */}
      <div style={styles.bgCircle1} />
      <div style={styles.bgCircle2} />

      <div style={styles.card}>
        {/* Logo */}
        <div style={styles.logoRow}>
          <Link to="/" style={styles.logo}>🔴 TireStore</Link>
        </div>

        <h2 style={styles.title}>Welcome Back</h2>
        <p style={styles.subtitle}>Login to your account</p>

        {error && (
          <div style={styles.errorBox}>
            ⚠️ {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={styles.field}>
            <label style={styles.label}>Email Address</label>
            <input
              style={styles.input}
              type="email"
              name="email"
              placeholder="you@example.com"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Password</label>
            <input
              style={styles.input}
              type="password"
              name="password"
              placeholder="Enter your password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>

          <button
            style={{ ...styles.button, opacity: loading ? 0.7 : 1 }}
            type="submit"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login →'}
          </button>
        </form>

        <p style={styles.switchText}>
          Don't have an account?{' '}
          <Link to="/register" style={styles.switchLink}>Register here</Link>
        </p>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f0f2f5 0%, #e8eaf0 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden',
    padding: '20px'
  },
  bgCircle1: {
    position: 'absolute',
    width: '400px',
    height: '400px',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(230,57,70,0.1) 0%, transparent 70%)',
    top: '-100px',
    right: '-100px'
  },
  bgCircle2: {
    position: 'absolute',
    width: '300px',
    height: '300px',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(230,57,70,0.07) 0%, transparent 70%)',
    bottom: '-80px',
    left: '-80px'
  },
  card: {
    background: '#fff',
    padding: '48px 40px',
    borderRadius: '20px',
    width: '100%',
    maxWidth: '420px',
    boxShadow: '0 8px 40px rgba(0,0,0,0.1)',
    border: '1px solid #e8eaf0',
    position: 'relative',
    zIndex: 1
  },
  logoRow: {
    textAlign: 'center',
    marginBottom: '28px'
  },
  logo: {
    color: '#e63946',
    fontSize: '22px',
    fontWeight: 'bold',
    textDecoration: 'none'
  },
  title: {
    color: '#1a1a2e',
    fontSize: '26px',
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: '6px'
  },
  subtitle: {
    color: '#888',
    fontSize: '14px',
    textAlign: 'center',
    marginBottom: '28px'
  },
  errorBox: {
    background: '#fff5f5',
    color: '#e63946',
    border: '1px solid #ffd0d3',
    borderRadius: '10px',
    padding: '12px 16px',
    fontSize: '14px',
    marginBottom: '20px'
  },
  field: {
    marginBottom: '18px'
  },
  label: {
    display: 'block',
    color: '#555',
    fontSize: '13px',
    fontWeight: '600',
    marginBottom: '8px'
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    borderRadius: '10px',
    border: '1px solid #e8eaf0',
    background: '#f8f9fa',
    color: '#333',
    fontSize: '14px',
    boxSizing: 'border-box',
    outline: 'none',
    transition: 'border-color 0.2s'
  },
  button: {
    width: '100%',
    padding: '14px',
    background: '#e63946',
    color: '#fff',
    border: 'none',
    borderRadius: '10px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginTop: '8px',
    boxShadow: '0 4px 16px rgba(230,57,70,0.3)',
    transition: 'opacity 0.2s'
  },
  switchText: {
    color: '#888',
    textAlign: 'center',
    marginTop: '24px',
    fontSize: '14px'
  },
  switchLink: {
    color: '#e63946',
    textDecoration: 'none',
    fontWeight: '600'
  }
};

export default LoginPage;